import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorIntercepterService implements HttpInterceptor{

  erreurMessage:any
  checkRefreshToken:boolean=false
  constructor(
    private authService :LoginService,
    private router:Router
  ){
  }
  
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
     
      return next.handle(request).pipe(
        timeout(10000),
        catchError(error => {
            if (error.name == "TimeoutError") {
            
            }else if(error.status == "400"){
              console.log("rien !")
            } else if (error.status == "403") {
             // this.refreshToken()
             localStorage.clear()
            this.router.navigate(['auth/signin'])

            } else if (error.status == "401") {
              console.log("rien !")
            } else if (error.status == "503" || error.status == "500") {
              console.log("rien !")
            } else {
              console.log("rien !")
            }
            return next.handle(request);
        })
    );
}

  async refreshToken(){
  if(this.checkRefreshToken ==false){
    this.checkRefreshToken=true;
   await this.authService.refresh()
    setTimeout(() => {
      this.checkRefreshToken=false
    }, 9000);
  }


}
}
